//
import { ModuleLayout } from "@/components/reusable_components/next"

//
import PurchaseInvoiceListView from "@/views/Purchase/PchPurchaseInvoice/list"
import PurchaseInvoiceUpdateView from "@/views/Purchase/PchPurchaseInvoice/update"

//
export default {
    path: "purchase_invoices",//"purchase_invoices",
    component: ModuleLayout,
    meta: {
        title: "Facturas de compra"
    },
    children: [
        {
            path: "",
            name: "purchase-invoice-list",
            component: PurchaseInvoiceListView,
        },
        {
            path: ":id",
            name: "purchase-invoice-update",
            component: PurchaseInvoiceUpdateView,
            meta: {
                title: "Datos de facturas de compra"
            },
        },
    ]
}